(function () {
  'use strict';

  var cards        = Array.from(document.querySelectorAll('.pdp-volume-card'));
  var variantInput = document.getElementById('pdp-variant-input');
  var priceCurrent = document.getElementById('pdp-price-current');
  var priceCompare = document.getElementById('pdp-price-compare');

  /* Money strings are pre-formatted by Liquid on each variant button, so the
     store's currency format is respected without formatting it here. */
  function updatePrice() {
    var active = document.querySelector('.pdp-volume-card.is-active');
    if (!active) return;

    if (priceCurrent) priceCurrent.textContent = active.dataset.priceMoney;

    if (priceCompare) {
      var compare = active.dataset.compareMoney;
      priceCompare.textContent = compare || '';
      priceCompare.hidden = !compare;
    }
  }

  function selectCard(card) {
    cards.forEach(function (c) {
      c.classList.remove('is-active');
      c.setAttribute('aria-checked', 'false');
    });
    card.classList.add('is-active');
    card.setAttribute('aria-checked', 'true');

    var variantId = card.dataset.variantId;

    /* Keep the form's hidden input in sync so ATC and payment buttons use the right variant */
    if (variantInput) variantInput.value = variantId;

    /* Sync URL so a page reload lands on the same variant */
    if (variantId && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }

    updatePrice();
  }

  cards.forEach(function (card) {
    card.addEventListener('click', function () { selectCard(card); });
  });

/* ── ATC — intercept form, POST via fetch, open bag drawer ── */
  var pdpForm = document.getElementById('pdp-form');
  if (pdpForm) {
    pdpForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var data = new FormData(pdpForm);
      fetch('/cart/add.js', { method: 'POST', body: data })
        .then(function (r) { return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('mekeni:bag:added'));
        })
        .catch(function () {});
    });
  }

/* ── Image carousel ──
     Only present when the product has 2+ images; the single-image case
     renders a bare <img> with no chrome, so there is nothing to wire up. */
  var carousel = document.getElementById('pdp-carousel');
  if (carousel) {
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('.pdp-carousel__slide'));
    var dots   = Array.prototype.slice.call(carousel.querySelectorAll('.pdp-carousel__dot'));
    var index  = 0;

    var show = function (next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var on = i === index;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    };

    carousel.querySelector('.pdp-carousel__nav--prev')
      .addEventListener('click', function () { show(index - 1); });
    carousel.querySelector('.pdp-carousel__nav--next')
      .addEventListener('click', function () { show(index + 1); });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); });
    });

    /* Swipe */
    var viewport = carousel.querySelector('.pdp-carousel__viewport');
    var startX = 0;
    viewport.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) < 40) return;
      show(dx < 0 ? index + 1 : index - 1);
    }, { passive: true });

    carousel.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); show(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
    });
  }
})();
